export const STATUS = {
  neu: { label: "Neu", color: "bg-slate-500/15 text-slate-300 border-slate-500/30", dot: "bg-slate-400" },
  kontaktversuch: { label: "Kontaktversuch", color: "bg-blue-500/15 text-blue-300 border-blue-500/30", dot: "bg-blue-400" },
  erreicht: { label: "Erreicht", color: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30", dot: "bg-cyan-400" },
  interesse: { label: "Interesse", color: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30", dot: "bg-indigo-400" },
  followup: { label: "Follow-up", color: "bg-amber-500/15 text-amber-300 border-amber-500/30", dot: "bg-amber-400" },
  angebot: { label: "Angebot", color: "bg-purple-500/15 text-purple-300 border-purple-500/30", dot: "bg-purple-400" },
  kunde: { label: "Kunde", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30", dot: "bg-emerald-400" },
  verloren: { label: "Verloren", color: "bg-rose-500/15 text-rose-300 border-rose-500/30", dot: "bg-rose-400" },
};

export const STATUS_ORDER = [
  "neu", "kontaktversuch", "erreicht", "interesse", "followup", "angebot", "kunde", "verloren",
];

export const SOURCES = [
  { value: "google_maps", label: "Google Maps" },
  { value: "empfehlung", label: "Empfehlung" },
  { value: "website", label: "Website" },
  { value: "telefon", label: "Telefon" },
  { value: "email", label: "E-Mail" },
  { value: "sonstiges", label: "Sonstiges" },
];

export const WEBSITE_STATES = [
  { value: "keine_website", label: "Keine Website" },
  { value: "stark_veraltet", label: "Stark veraltet" },
  { value: "verbesserungsfaehig", label: "Verbesserungsfähig" },
  { value: "gute_website", label: "Gute Website" },
  { value: "unbekannt", label: "Unbekannt" },
];

export const PRIORITIES = [
  { value: "hoch", label: "Hoch", color: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
  { value: "mittel", label: "Mittel", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  { value: "niedrig", label: "Niedrig", color: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
];

export const LOST_REASONS = [
  { value: "kein_interesse", label: "Kein Interesse" },
  { value: "kein_bedarf", label: "Kein Bedarf" },
  { value: "bestehender_anbieter", label: "Bestehender Anbieter" },
  { value: "preis", label: "Preis" },
  { value: "spaeter_eventuell", label: "Später eventuell" },
  { value: "nicht_erreichbar", label: "Nicht erreichbar" },
  { value: "sonstiges", label: "Sonstiges" },
];

export const CALL_RESULTS = [
  { value: "nicht_erreicht", label: "Nicht erreicht" },
  { value: "inhaber_nicht_da", label: "Inhaber nicht da" },
  { value: "rueckruf_gewuenscht", label: "Rückruf gewünscht" },
  { value: "email_gewuenscht", label: "E-Mail gewünscht" },
  { value: "grundsaetzlich_interessiert", label: "Grundsätzlich interessiert" },
  { value: "angebot_gewuenscht", label: "Angebot gewünscht" },
  { value: "kein_bedarf", label: "Kein Bedarf" },
  { value: "hat_anbieter", label: "Hat bereits Anbieter" },
  { value: "zu_teuer", label: "Zu teuer" },
  { value: "kein_interesse", label: "Kein Interesse" },
  { value: "sonstiges", label: "Sonstiges" },
];

export const ACTIVITY_META = {
  telefonat: { label: "Telefonat", icon: "Phone", color: "text-emerald-400" },
  telefonversuch: { label: "Telefonversuch", icon: "PhoneMissed", color: "text-amber-400" },
  email: { label: "E-Mail", icon: "Mail", color: "text-blue-400" },
  notiz: { label: "Notiz", icon: "StickyNote", color: "text-slate-400" },
  followup: { label: "Follow-up", icon: "CalendarClock", color: "text-indigo-400" },
  angebot: { label: "Angebot", icon: "FileText", color: "text-purple-400" },
  statusaenderung: { label: "Statusänderung", icon: "GitBranch", color: "text-cyan-400" },
};

export const fmtEUR = (v) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export const relativeDays = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const diff = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
  if (diff === 0) return "heute";
  if (diff === 1) return "gestern";
  return `vor ${diff} Tagen`;
};

export const labelOf = (list, value) => list.find((x) => x.value === value)?.label || value || "—";
